import { message } from "antd";
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext<any>(null!);

function getInitialUser() {
  const user = sessionStorage.getItem("user");
  return user ? JSON.parse(user) : null;
}

function getInitialToken() {
  const token = sessionStorage.getItem("token");
  return token ? token : null;
}

function getInitialCanImpersonate() {
  const canImpersonate = sessionStorage.getItem("canImpersonate");
  return canImpersonate ? JSON.parse(canImpersonate) : false;
}

const AuthProvider = ({ children }: any) => {
  const [user, setUser] = useState<any>(getInitialUser);
  const [token, setToken] = useState<any>(getInitialToken);
  const [canImpersonate, setCanImpersonate] = useState<any>(getInitialCanImpersonate);
  const [side, setSide] = useState<any>(false);

  const navigate = useNavigate();

  const signin = (payload: any, redirect: any) => {
    const { user, token, canImpersonate } = payload;
    if (token) {
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("token", JSON.stringify(token));
      sessionStorage.setItem("canImpersonate", JSON.stringify(canImpersonate));
      setUser(user);
      setToken(token);
      if (redirect) {
        navigate(`${redirect}`);
      } else {
        navigate("/");
      }
      message.success("Logged in successfully");
    }
  };



  const impersonateUser = (payload: any) => {
    const { user, token } = payload;
    if (token) {
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("token", token);
      setUser(user);
      setToken(token);
      message.success("Impersonated successfully.");
    }
  };


  const updateUser = (user: any) => {
    sessionStorage.setItem("user", JSON.stringify(user));
    setUser(user);
  };

  const signout = () => {
    sessionStorage.setItem("user", "");
    sessionStorage.setItem("token", "");
    sessionStorage.setItem("canImpersonate", "");
    setUser(null);
    setToken(null);
    setCanImpersonate(false);
    navigate("/");
    message.success("Logged out successfully");
  };

  const handleFetchAuth = async () => {
    if (token) {
      setToken(token);
    }
  };

  let value = {
    user,
    setUser,
    token,
    side,
    setSide,
    setToken,
    signin,
    signout,
    updateUser,
    impersonateUser,
    canImpersonate,
  };

  useEffect(() => {
    handleFetchAuth();
  }, []);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider };
